<template>
    <div>
        <br />
        <b-table :items="activeUsers" :fields="usersTableFields" @sort-changed="sortList">
            <template #cell(expand)="row">
                <div @click.stop="row.toggleDetails" class="clickable" style="padding: 8px;">
                    <i :class="'fa-solid fa-' + (row.item._showDetails ? 'chevron-down' : 'chevron-right')" style="padding-left: 5px;"></i>
                </div>
            </template>
            <template #cell(id)="data">
                <b-avatar v-if="data.value == undefined || !data.value" size="1.5rem" style="margin-right: 5px;"></b-avatar>
                <b-avatar v-else variant="success" size="1.5rem" :text="data.value.substring(0, 2).toUpperCase()" style="margin-right: 5px;"></b-avatar>
                <a href="#">{{ (data.value == undefined || !data.value ? 'Unassigned' : data.value) }}</a>
            </template>
                
            <template #row-details="row">
                <b-form-group
                    label-cols-lg="2"
                    label="Permissions"
                    label-size="sm"
                    label-class="font-weight-bold pt-0"
                    class="mb-3"
                    @change="hasChanged"
                >
                    <b-form-checkbox-group switches :id="'permissions-checkbox-group' + row.index"  v-model="row.item.user_level" :options="permission_levels" name="permissions" @change="checkForChanges(row)"></b-form-checkbox-group>
                </b-form-group>
                <b-form-group
                    label-cols-lg="2"
                    label="Sites"
                    label-size="sm"
                    label-class="font-weight-bold pt-0"
                    class="mb-3"
                >
                    <b-form-checkbox-group switches stacked :id="'sites-checkbox-group' + row.index" v-model="row.item.sites" :options="sitesList" name="sites" @change="checkForChanges(row)"></b-form-checkbox-group>
                </b-form-group>
                <b-button variant="success" :disabled="!hasChangedArray[row.index]" style="position: relative; float: right; margin-right: 20px; margin-bottom: 20px;" @click="saveUserDetails(row.item)"> Update User </b-button>
            </template>
        </b-table>
    </div>
</template>

<script>

export default {
    name: "UserManagement",
    components: {},
    data: function () {
        return {
            activeUsers: [],
            sites: [],
            sitesList: [],
            usersTableFields: [
                { key: 'expand', label: '', sortable: false, thStyle: {width: '20px', 'max-width': '20px' }, tdClass: 'tableExpand'},
                { key: 'id', label: 'Username', stickyColumn: true, sortable: true, thStyle: {} },
                // { key: 'user_level', label: 'Permissions', thStyle: {width: '200px', 'max-width': '200px'} },
                // { key: 'sites', label: 'Sites', thStyle: {width: '200px', 'max-width': '200px'} },
            ],
            permission_levels: [
                { value: 'manager', text: 'Manager' },
                { value: 'fertilisation', text: 'Fertilisation' },
                { value: 'stock', text: 'Stock' },
                { value: 'user', text: 'User' },
            ],
            hasChanged: true,
            hasChangedArray: []
        };
    },
    props: {},

    mounted: async function () {
        this.activeUsers = this.$parent.$parent.users;
        this.activeUsers.sort(this.sortList);

        this.sites = this.$parent.$parent.sites;
        this.sites.sort(this.sortList)
        
        this.sites.forEach(site => {
            this.sitesList.push(site.id) 
        })
    },
    methods: {
        sortList(a, b){
            if ( a.id < b.id ) return -1;
            if ( a.id > b.id ) return 1;
            return 0;
        },
        async saveUserDetails(item ){
            let showDetailsMemory = item._showDetails;
            delete item._showDetails;
            
            try {
                await this.$http.put  (
                    process.env.VUE_APP_AQUACULTURE_CRUD_API_URI,
                    {"TableName": "lifechain-users", "Item": item},             
                    { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken } }
                )
                const index = this.activeUsers.findIndex(user => user.id === item.id);
                this.$set(this.hasChangedArray, index, false); 
            
            } catch (error) {
                console.log(error);
            }
            item._showDetails = showDetailsMemory;
        },
        checkForChanges(row) {
            const index = row.index;
            if (row.item.user_level || row.item.sites) this.$set(this.hasChangedArray, index, true); // Set hasChanged to true for this row if either user_level or sites is true
            else this.$set(this.hasChangedArray, index, false); // Set hasChanged to false for this row if both user_level and sites are false
        },
    }
};
</script>

<style>

td.tableExpand {
    padding: 0px !important;
}
</style>
